import React from 'react';
import { IconProps } from './model/IconInterface';

const BarcodeIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 6v12" />
      <path d="M7 6v12" />
      <path d="M10 6v12" />
      <path d="M13 6v12" />
      <path d="M16 6v12" />
      <path d="M19 6v12" />
    </svg>
  );
};

export default BarcodeIcon;
